// @flow

export default function logoutUrl(): string {
  return '/logout'
}
